import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import EshopItemNew from '../components/EshopItemNew.js';
import EshopItemEdit from '../components/EshopItemEdit.js';

const renderPrice = (value) => `${value}`;

export default function EshopItem({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [dataDetail, setDataDetail] = useState({});
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);

	useEffect(() => {
		getData('');
	}, []);

	const getData = (search) => {
		setLoading(true);

		post('getListItem', {search: search})
			.then((res) => {
				setData(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const saveInWallet = (index, id, val) => {
		setLoading(true);

		post('saveInWallet', {ID: id, SHOWINWALLET: val})
			.then((res) => {
				data[index].SHOWINWALLET = res.data;
				setData([...data]);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateEshopItemRowNew = (row) => {
		setData([row, ...data]);
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateEshopItemRowEdit = (row) => {
		const newData = data.map((item) => {
			if (item.ID === row.ID) {
				return row;
			}

			return item;
		});

		setData(newData);
	};

	const updateEshopItemRowDelete = (row) => {
		const newData = data.filter((item) => {
			return item.ID !== row;
		});

		setData(newData);
	};

	const list = data.map((item, index) => {
		const isInWallet = parseInt(item.SHOWINWALLET) === 1;

		return (
			<article className="eshop-page__item-admin-row" key={'item_' + index}>
				<div className="eshop-page__item-admin-actions">
					<button
						type="button"
						className={`eshop-page__icon-button eshop-page__item-admin-action${isInWallet ? ' is-active' : ''}`}
						onClick={() => saveInWallet(index, item.ID, item.SHOWINWALLET)}
					>
						<img className={`icon1 eshop ${isInWallet ? 'active' : ''}`} alt="" />
					</button>
					<button type="button" className="eshop-page__icon-button eshop-page__item-admin-action" onClick={() => handleEdit(item)}>
						<img className="icon1 edit" alt="" />
					</button>
				</div>

				<div className="eshop-page__item-admin-main">
					<div className="eshop-page__item-admin-title">{item.SORTORDER}. {item.NAME}</div>
				</div>

				<div className="eshop-page__item-admin-price">{renderPrice(item.PRICE)}</div>
			</article>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showNew handleNew={handleNew} />
				<EshopItemNew showNew={showNew} closeNew={closeNew} updateEshopItemRowNew={updateEshopItemRowNew} />
				<EshopItemEdit showEdit={showEdit} closeEdit={closeEdit} updateEshopItemRowEdit={updateEshopItemRowEdit} updateEshopItemRowDelete={updateEshopItemRowDelete} data={dataDetail} />

				<div className={`page eshop-page eshop-page--item-admin ${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="eshop-page__shell">
						<section className="eshop-page__section">
							<div className="eshop-page__section-head">
								<h2 className="eshop-page__section-title">Položky e-shopu</h2>
							</div>
							<div className="eshop-page__item-admin-list">
								{list.length > 0 ? list : <div className="eshop-page__empty">Seznam položek je zatím prázdný.</div>}
							</div>
						</section>
					</div>
				</div>
			</div>
		</>
	);
}
